function ArrowRightIcon({ color, opacity = 0.2 }) {
    return (
        <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.445" y="0.445" width="41.11" height="41.11" rx="20.555" fill="white" />
            <path
                d="M14.8125 21H27.1875M27.1875 21L22.125 15.9375M27.1875 21L22.125 26.0625"
                stroke="#5E718D"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <rect x="0.445" y="0.445" width="41.11" height="41.11" rx="20.555" stroke="#D7DFE9" strokeWidth="0.89" />
        </svg>
    );
}

export default ArrowRightIcon;
